var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20.1733C0 9.12764 8.9543 0.17334 20 0.17334C31.0457 0.17334 40 9.12764 40 20.1733C40 31.219 31.0457 40.1733 20 40.1733C8.9543 40.1733 0 31.219 0 20.1733Z",
    fill: "#FFEAE5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_290_1172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2137 21.3258L25.8356 17.2307H21.9452V14.5744C21.9452 13.4537 22.4877 12.3608 24.2301 12.3608H26V8.87436C26 8.87436 24.3945 8.59766 22.8603 8.59766C19.6548 8.59766 17.5616 10.5595 17.5616 14.1095V17.2307H14V21.3258H17.5616V31.2261C18.2767 31.3396 19.0082 31.3977 19.7534 31.3977C20.4986 31.3977 21.2301 31.3396 21.9452 31.2261V21.3258H25.2137Z",
    fill: "#FFEAE5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_290_1172"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7.99756,
    width: 24,
    height: 24,
    rx: 6,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.690ebf3e2182614b6aecf4af50ab9641.svg";
export { ForwardRef as ReactComponent };